import { createSlice } from '@reduxjs/toolkit';
import { setAutoFreeze } from 'immer';

setAutoFreeze(false);  // 禁止凍結

const localCountry = JSON.parse(localStorage.getItem('country'));

export const countrySlice = createSlice({
	name: 'country',
	initialState: localCountry ?? [],
	reducers: {
		countryUpdate: (state, action) => {
			localStorage.country = JSON.stringify(action.payload);
			return action.payload;
		},
	},
});

export const countrySelect = (state) => state.country;
export const { countryUpdate } = countrySlice.actions;
export default countrySlice.reducer;